
define('template!sdcSocial',[''],function(template){return '<span class="fa fa-{{model.typeFontAwesome()}}"></span>\r\n<ng-transclude></ng-transclude>\r\n';});

